import {CompanyRegularIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

type Props = {
    headline: string;
    body: string;
};

export function CompanyOverview(props: Props) {
    return (
        <div className='mb-16'>
            <Stack spacing={4}>
                <Stack isHorizontal={true} spacing={8} alignItems='center'>
                    <CompanyRegularIcon
                        wrapWithDiv={false}
                        size={18}
                        style={{color: 'var(--grey)'}}
                    />
                    <Body size='small' color='dark' isBold={true}>
                        Company Profile
                    </Body>
                </Stack>
                <div className='mt-4'>
                    <Body size='small'>
                        <span className='font-bold'>{props.headline}</span> {props.body}
                    </Body>
                </div>
            </Stack>
        </div>
    );
}
